import React from "react";
import { Layout } from "../../layouts/Layout";
import {
  CHECK_ICON,
  BLOG_DETAILS03,
  BLOG_DETAILS04
} from "../../lib/assets";
import { VideoPlayerOne } from "../../components/VideoPlayers/VideoPlayerOne";

const BlogDetailsPage4 = () => {
  return (
    <Layout  footer ={2} breadcrumb={"Blog Details"} title={"The Consultant Advantage"}>
      {/* project-details-area */}
      <section className="project-details-area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="project-details-wrap">
                <div className="row">
                  {/* image */}
                 {/* <div className="col-001">
                    <div className="project-details-thumb">
                      <img src={BLOG_DETAILS04} alt="" style={{width:"1207px", height:"440px"}} />
                    </div>
                  </div>*/}

                  {/* project details info */}
                 </div>

                <div className="project-details-content">
                  <h2 className="title">Strategic Solutions for Modern Businesses: The Consultant Advantage                  </h2>
                  <p>
                  In today's fast-paced business landscape, organizations face numerous challenges, 
                  from navigating rapid technological change to staying ahead of the competition. 
                  To overcome these obstacles and achieve success, many businesses turn to management 
                  consultants for strategic guidance and support.
                  </p>
                  <p>
                  Management consultants bring a unique set of skills and expertise to the table. They 
                  provide an unbiased, fresh perspective on your business, helping you identify areas for 
                  improvement and opportunities for growth.
                  </p>
                  <div className="pd-optimized-wrap">
                    <h3 className="title-two">Expertise and Knowledge</h3>
                    <p>
                    Consultants bring a wealth of specialized knowledge and expertise to the table, 
                    cultivated through years of hands-on experience and in-depth exposure to a wide range of 
                    clients, industries, and business challenges. Their proficiency spans various domains, 
                    allowing them to analyze complex problems, offer tailored solutions, and implement best 
                    practices that drive growth and efficiency. By leveraging their insights, businesses gain 
                    access to cutting-edge strategies and proven methodologies that are difficult to 
                    replicate in-house, enabling them to navigate industry-specific hurdles and achieve 
                    their objectives effectively
                    </p>
                  </div>
                  <div className="pd-inner-wrap">
                    <div className="row align-items-center">
                      <div className="col-41">
                        <div className="content">
                          <h3 className="title-two">
                          By leveraging the expertise <br/>and guidance of management consultants, businesses can
                          </h3>
                          <br/>
                          <ul className="list-wrap">
                            <li>
                              <img src={CHECK_ICON} alt="" />
                              Improve Operational Efficiency
                            </li>
                            <li>
                              <img src={CHECK_ICON} alt="" />
                              Enhance Customer Experience
                            </li>
                            <li>
                              <img src={CHECK_ICON} alt="" />
                              Drive Innovation
                            </li>
                            <li>
                              <img src={CHECK_ICON} alt="" />
                              Unlock Business Potential
                            </li>
                          </ul>
                          <p className="info-two">
                          In today's complex and rapidly changing business environment, management consultants offer 
                          a valuable advantage. By providing objective perspective, expertise, strategic guidance, and 
                          change management support, consultants help businesses unlock their full potential and achieve 
                          success.
                          </p>
                        </div>
                      </div>

                      <div className="col-59">
                        <div className="thumb">
                          <img src={BLOG_DETAILS03} alt="" style = {{width:"504px",height:"465px", paddingLeft:"100px", width:"100%", borderRadius:"50%"}} />

                   {/*       <VideoPlayerOne
                            src={"https://www.youtube.com/watch?v=6mkoGSqTqFI"}
                          />*/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogDetailsPage4;
